import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../../../../common/common_components/pagination_holder/Pagination_Holder";
import { formatDate } from "../../../../../../../../utils/common";

const Accuracy_Report_Table = ({
  accuracydetails,
  currentPage,
  setCurrentPage,
}) => {
  const accuracies = accuracydetails?.data || [];

  const itemsPerPage =
    accuracydetails?.per_page || accuracydetails?.data?.length || 0;

  const totalPages = accuracydetails?.total_pages;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            <thead>
              <tr>
                <th rowSpan="2">Sr.No</th>
                <th rowSpan="2">Date</th>
                <th rowSpan="2">Test Method</th>
                <th rowSpan="2">Sample Id</th>
                <th rowSpan="2">Check By</th>
                <th rowSpan="2">Remark</th>
                <th rowSpan="2">Type Verification Of</th>
                <th colSpan="2">Certified</th>
                <th rowSpan="2">Tested Value</th>
                <th rowSpan="2">Accuracy Acceptance</th>
                <th rowSpan="2">Certified Value (Overall)</th>
              </tr>
              <tr>
                <th>Parameter</th>
                <th>Value</th>
              </tr>
            </thead>

            <tbody>
              {accuracies && accuracies.length > 0 ? (
                accuracies.map((accuracy, index) => {
                  const params = accuracy.Accuracy_Parameters || [];

                  if (params.length === 0) {
                    return (
                      <tr key={accuracy.id}>
                        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                        <td>{formatDate(accuracy?.date) || "-"}</td>

                        <td>{accuracy.Type_Of_Verification?.name || "-"}</td>
                        <td colSpan={5} className="text-center">
                          No Parameters
                        </td>
                      </tr>
                    );
                  }

                  return params.map((param, paramIndex) => (
                    <tr key={`${accuracy.id}-${param.id}`}>
                      {/* Grouped fields */}
                      {paramIndex === 0 && (
                        <>
                          <td rowSpan={params.length}>
                            {(currentPage - 1) * itemsPerPage + index + 1}
                          </td>

                          <td rowSpan={params.length}>
                            {formatDate(accuracy?.date) || "-"}
                          </td>

                          <td rowSpan={accuracy.Accuracy_Parameters.length}>
                            {accuracy?.Test_Method?.name || "-"}
                          </td>
                          <td rowSpan={accuracy.Accuracy_Parameters.length}>
                            {accuracy?.Sample_Management?.unique_id || "-"}
                          </td>
                          <td rowSpan={accuracy.Accuracy_Parameters.length}>
                            {accuracy?.User?.name || "-"}
                          </td>
                          <td rowSpan={accuracy.Accuracy_Parameters.length}>
                            {accuracy?.remark || "-"}
                          </td>

                          <td rowSpan={params.length}>
                            {accuracy.Type_Of_Verification?.name || "-"}
                          </td>
                        </>
                      )}

                      {/* Parameter */}
                      <td>{param.Parameter?.name || "-"}</td>

                      {/* Certified Value */}
                      <td>{param.certified_value || "-"}</td>

                      {/* Tested Value */}
                      <td>{param.result_value || "-"}</td>

                      {/* Acceptance */}
                      {paramIndex === 0 && (
                        <td rowSpan={params.length}>Accepted</td>
                      )}

                      {/* Overall Certified */}
                      {paramIndex === 0 && (
                        <td rowSpan={params.length}>
                          {accuracy.certified_value || "-"}
                        </td>
                      )}
                    </tr>
                  ));
                })
              ) : (
                <tr>
                  <td colSpan={8} className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">
            Showing {(currentPage - 1) * itemsPerPage + 1} To{" "}
            {Math.min(currentPage * itemsPerPage, accuracydetails?.total || 0)}{" "}
            Of {accuracydetails?.total || 0} Entries
          </p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default Accuracy_Report_Table;
